import { Environment } from './environment.model';

export const environment: Environment = {
    production: false,
    apiBaseUrl: '/api/idp',
    sapBusinessApiBaseUrl: '/api/sap-business',
    oneWelcomeApiBaseUrl: '/api',
    authClientId: '2d8bf063-ca23-43cc-a881-287ef16538c2',
    authAuthority: 'https://login.microsoftonline.com/64458159-0d9a-4d84-966f-1a13c0ac7a34',
    authRedirectUri: 'https://testnsaccountmanagement.ns.nl',
    // authRedirectUri: 'http://localhost:4200'
};
